enum QueryKeys {
	token = 'token',
	idps = 'idps',
	idpGuides = 'idpGuides',
	configurations = 'configurations',
	sp = 'sp',
	userAttributes = 'userAttributes',
	roles = 'roles',
	theme = 'theme',
	appConfig = 'appConfig',
	fgaMappableSchema = 'fgaMappableSchema',
	dnsProviders = 'dnsProviders',
	dnsServers = 'dnsServers',
	verifyDomain = 'verifyDomain',
	featureFlags = 'featureFlags',
	code = 'code',
	err = 'err',
	ssoCallback = 'ssoCallback'
}

export default QueryKeys;
